export default __webpack_public_path__ + "static/media/fondo.1be80d32.jpg";